import { render, staticRenderFns } from "./UserBonuses.vue?vue&type=template&id=a2d70c9a&scoped=true"
import script from "./UserBonuses.vue?vue&type=script&lang=js"
export * from "./UserBonuses.vue?vue&type=script&lang=js"
import style0 from "./UserBonuses.vue?vue&type=style&index=0&id=a2d70c9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d70c9a",
  null
  
)

export default component.exports